import { render, staticRenderFns } from "./jigsaw.vue?vue&type=template&id=a68c2c30&scoped=true"
import script from "./jigsaw.vue?vue&type=script&lang=js"
export * from "./jigsaw.vue?vue&type=script&lang=js"
import style0 from "./jigsaw.vue?vue&type=style&index=0&id=a68c2c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68c2c30",
  null
  
)

export default component.exports